import { createSelector } from 'reselect';
import ManualPreadviceTransactionsColumns from '../../containers/ManualPreadviceTransactionsColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.MANUAL_PREADVICE_TRANSACTIONS.isLoading;
export const getCheckedRows = (state) => state.listing.MANUAL_PREADVICE_TRANSACTIONS.selectedRows;
export const getData = TableDefinitions.MANUAL_PREADVICE_TRANSACTIONS.getDataFunction();
export const getColumns = createSelector(getData, ManualPreadviceTransactionsColumns);
